import "./views.scss";

import { useEffect } from "react";

import PersonalizeLater from "../components/buttons/PersonalizeLater";
import PrimaryButton from "../components/buttons/PrimaryButton";
import DynamicFormField from "../components/forms/formFields/DynamicFormField";
import { useFormFlowContext } from "../components/forms/FormFlowContext";
import { triggerCommunityRegistrationView } from "../helpers/observability/analytics";
import appSettings from "../settings/appSettings";

const BadgesPage = ({ formMethods, handleClickPersonalizeLater }) => {
  const { pageForward } = useFormFlowContext();
  const { badges } = appSettings;
  const { getFormState } = formMethods;
  const formState = getFormState();

  useEffect(() => {
    triggerCommunityRegistrationView({
      event_action: "personalize",
      event_label: "Do you have any affiliations with the following?"
    });
  }, []);

  const field = {
    type: "multi-select-checkboxes",
    items: badges.map((badge) => ({ ...badge, label: badge.name }))
  };

  return (
    <div className="views display-grid gap-tight">
      <div className="header">
        <h1 className="serif">
          <strong>Getting to Know You</strong>
        </h1>
      </div>
      <p className="base intro">
        Do you belong to any of the following community groups at World Vision? 
        The information you provide will be featured on your profile.
      </p>
      <DynamicFormField
        formMethods={formMethods}
        type={field.type}
        field={field}
        formFields={formState?.fields}
      />
      <footer className="footer">
        <PrimaryButton handleClick={pageForward}>Next</PrimaryButton>
        <PersonalizeLater handleClick={handleClickPersonalizeLater} />
      </footer>
    </div>
  );
};

export default BadgesPage;
